import { render, staticRenderFns } from "./LogoLoadsureTagline.vue?vue&type=template&id=1794c2b2&scoped=true&lang=pug"
import script from "./LogoLoadsureTagline.vue?vue&type=script&lang=ts"
export * from "./LogoLoadsureTagline.vue?vue&type=script&lang=ts"
import style0 from "./LogoLoadsureTagline.vue?vue&type=style&index=0&id=1794c2b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1794c2b2",
  null
  
)

export default component.exports